// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_about_about_module_ts":"f2e20de7c494322a","src_app_features_calls_calls_module_ts":"675ef9a650b27828"}[chunkId] + ".js";
};